import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@material-ui/core';

import * as getTime from '~/skills/getTime';
import Actions from '~/Actions';
import Actions_Wind from '~/Actions_Wind';

import { EAA_Item, EAA_ItemContainer, EAA_Row, EAA_TitleText, EAA_Date, EAA_Memo, EAA_Input, EAA_ErrorText, EAA_Upload, EAA_Status, EAA_UpdateTime, EAA_Select, EAA_BottomBtn } from '~/components/EditAndAddItem';

import PageTitle from '~/components/PageTitle';
import SearchBar from '~/components/SearchBar';
import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';

import Sub1 from './Sub1';
import Sub2 from './Sub2';
import Sub3 from './Sub3';
import Sub4 from './Sub4';
import Sub5 from './Sub5';
import Sub6 from './Sub6';
import Sub7 from './Sub7';

const modeInfo = {
  add: {
    title: '海事工程_新增',
  },
  edit: {
    title: '海事工程_編輯',
  },
  view: {
    title: '海事工程_檢視',
  },
};
const titleWidth = 150;
const errorLeft = titleWidth + 20;

class AddAndEdit extends Component {
  state={ data: {}, old_data: {}, mode: '', canSend: true, errorAry: [] }

  componentDidMount () {
    const { id, getIAOMaritimeIdDetail, getBaseData, mode = '', setPageText } = this.props;
    setPageText(modeInfo[mode].title);
    if (mode !== 'add')getIAOMaritimeIdDetail(id);
    getBaseData();
  }

  componentDidUpdate (preProps) {
    const { IAOMaritimeIdDetail: preIAOMaritimeIdDetail = {} } = preProps;
    const { IAOMaritimeIdDetail = {}, mode } = this.props;
    if (Object.keys(preIAOMaritimeIdDetail).length === 0 && Object.keys(IAOMaritimeIdDetail).length > 0 && (mode !== 'add')) {
      this.setState({ data: IAOMaritimeIdDetail, old_data: IAOMaritimeIdDetail });
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    clearKey('IAOMaritimeIdDetail');
    clearKey('PageText');
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  }

  getSendBody=() => {
    const { data } = this.state;
    const body = {
      project: data.project || '',
      detailitem: data.detailitem || '',
      partner: data.partner || '',
      partner_other: data.partner_other || '',
      have_doc: data.have_doc || '',
      have_prove: data.have_prove || '',
      select_data_type: data.select_data_type || '',
      contract_date_type: data.contract_date_type || '',
      contract_month: data.contract_month || '',
      contract_date: data.contract_date || '',
      other_plan: data.other_plan || '',
      other_plan_upload_files: data.other_plan_upload_files || [],
      contract_sign_date: data.contract_sign_date || '',
      provide_start_date: data.provide_start_date || '',
      provide_end_date: data.provide_end_date || '',
      provide_num: data.provide_num || '',
      op_content: data.op_content || '',
      op_content_detail: data.op_content_detail || '',
      contract_price: data.contract_price || '',
      factor_content: data.factor_content || '',
      sub1: data.sub1 || [],
      sub2: data.sub2 || [],
      sub3: data.sub3 || [],
      sub4: data.sub4 || [],
      sub5: data.sub5 || [],
      sub6: data.sub6 || [],
      sub7: data.sub7 || [],

      windcontract_id: Actions_Wind.wind_id(),
    };
    return body;
  }

  add=(status = {}) => {
    this.setState({ canSend: false });
    const body = { ...this.getSendBody(), ...status };
    this.props.postAddNewIAOMaritimeData(body);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });

  edit=(status = {}) => {
    const { id, putIAOMaritimeData } = this.props;
    this.setState({ canSend: false });
    const body = { ...this.getSendBody(), ...status };
    putIAOMaritimeData(id, body);
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      returnInputValue(data.project) === '', // 0 項目
      returnInputValue(data.detailitem) === '', // 1 細項
      returnInputValue(data.partner) === '', // 2 合作廠商 選項
      data.partner === '其他' && returnInputValue(data.partner_other) === '', // 3 合作廠商 自行新增
      data.partner === '國外廠商' && returnInputValue(data.have_doc) === '', // 4 有無文件
      data.partner === '國內合資公司' && returnInputValue(data.have_prove) === '', // 5 有無檢測無能量證明
      false, // returnInputValue(data.select_data_type) === '', // 6 選擇提供佐證資料種類
      data.select_data_type !== '有條件協議' && returnInputValue(data.contract_date_type) === '', // 7 提供正式商業合約日期 選項
      data.select_data_type !== '有條件協議' && returnInputValue(data.contract_month) === '', // 8 提供正式商業合約日期 幾月
      data.select_data_type !== '有條件協議' && returnInputValue(data.contract_date) === '', // 9 提供正式商業合約日期 日期
      data.select_data_type === '替代方案' && returnInputValue(data.other_plan) === '', // 10 替代方案 簡述
      data.select_data_type === '替代方案' && (data.other_plan_upload_files || []).length === 0, // 11 替代方案 檔案
      data.select_data_type !== '替代方案' && returnInputValue(data.contract_sign_date) === '', // 12 合約簽署日期
      data.select_data_type !== '替代方案' && returnInputValue(data.provide_start_date) === '', // 13 船舶供應時間 開始時間
      data.select_data_type !== '替代方案' && returnInputValue(data.provide_end_date) === '', // 14 船舶供應時間 結束時間
      (returnInputValue(data.provide_start_date) !== '') && (returnInputValue(data.provide_end_date) !== '') && (getTime.returnDate(data.provide_start_date) > getTime.returnDate(data.provide_end_date)), // 15 『船舶供應時間 - 開始』 大於 『船舶供應時間 - 結束』
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  renderDialog=() => {
    const {
      mode = '',
      IAMMItemList = [],
      IAMTPartnerList = [],
      IAMTEvidenceTypeList = [],
      IAMTContractDateList = [],
    } = this.props;
    const { data = {}, old_data = {}, canSend, errorAry } = this.state;
    const isCheck = this.state.mode === 'check';
    const isEdit = mode === 'edit';
    const disabled = mode === 'view' || isCheck;
    // const { status = '0' } = data;
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const checkFilesChange = label => isCheck ? JSON.stringify(data[label] || []) !== JSON.stringify(old_data[label] || []) : false;
    const checkSubChange = (n, ary = []) => isCheck ? JSON.stringify(data[`sub${n}`] || ary) !== JSON.stringify(old_data[`sub${n}`] || ary) : false;
    const allRight = errorAry.indexOf(true) === -1;

    const returnIdList = value => {
      for (const o of IAMMItemList) {
        if (value === o.value) return o.idList;
      }
      return [];
    }; const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const returnForceOpen = ({ least = 0, most = 0 }) => {
      for (let i = 0; i < errorAry.length; i++) {
        if (i >= least && i <= most && errorAry[i]) return true;
      }
      return false;
    };

    return (
      <div style={{ width: '80%', maxHeight: '80%', backgroundColor: 'white', borderRadius: 39, alignItems: 'center', display: 'flex', flexDirection: 'column', padding: 20, overflowY: 'auto' }}>
        <PageTitle text={modeInfo[mode].title} />

        <SearchBar style={{ marginTop: 8 }} defaultOpen forceOpen={returnForceOpen({ least: 0, most: 5 })}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='項目' bol haveChange={checkChange('project')} />
                <EAA_Select displayBorder disabled={disabled} list={IAMMItemList} value={returnInputValue(data.project)} onChange={data => this.changeData({ label: 'project', data }, () => this.changeData({ label: 'detailitem', data: '' })) } />
              </EAA_ItemContainer>
              {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='細項' bol haveChange={checkChange('detailitem')} />
                <EAA_Select displayBorder disabled={disabled || returnIdList(data.project).length === 0} list={returnIdList(data.project)} value={returnInputValue(data.detailitem)} onChange={data => this.changeData({ label: 'detailitem', data })} />
              </EAA_ItemContainer>
              {errorAry[1] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='合作廠商' bol haveChange={checkChange('partner') || checkChange('partner_other')} />
                <EAA_Select displayBorder disabled={disabled} list={IAMTPartnerList} value={returnInputValue(data.partner)} onChange={data => this.changeData({ label: 'partner', data })} />
              </EAA_ItemContainer>
              {errorAry[2] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
            </EAA_Item>
            {data.partner === '其他' && (
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_Input displayBorder disabled={disabled} hint='自行新增廠商名稱' value={returnInputValue(data.partner_other)} onChange={data => this.changeData({ label: 'partner_other', data })} />
                </EAA_ItemContainer>
                {errorAry[3] && <EAA_ErrorText marginLeft={0} text='請輸入' />}
              </EAA_Item>
            )}
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='有無文件' bol={data.partner === '國外廠商'} haveChange={checkChange('have_doc')} />
                <div style={{ flex: 1, marginRight: 12, display: 'flex' }}>
                  <CircleCheckBox disabled={disabled} value={data.have_doc === '1'} onClick={() => this.changeData({ label: 'have_doc', data: '1' }) } />
                  <div style={{ marginRight: 8 }}>有</div>
                  <CircleCheckBox disabled={disabled} value={data.have_doc === '2'} onClick={() => this.changeData({ label: 'have_doc', data: '2' }) } />
                  <div>無</div>
                </div>
              </EAA_ItemContainer>
              {errorAry[4] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
            </EAA_Item>
          </EAA_Row>

          <Sub1 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} checkSubChange={checkSubChange} />

          <Sub2 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} checkSubChange={checkSubChange} />

          {data.partner === '國內合資公司' && (
            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='有無檢測無能' subtitle='量證明' subtitleColor='black' bol haveChange={checkChange('have_prove')} />
                  <div style={{ flex: 1, marginRight: 12, display: 'flex' }}>
                    <CircleCheckBox disabled={disabled} value={data.have_prove === '1'} onClick={() => this.changeData({ label: 'have_prove', data: '1' }) } />
                    <div style={{ marginRight: 8 }}>有</div>
                    <CircleCheckBox disabled={disabled} value={data.have_prove === '2'} onClick={() => this.changeData({ label: 'have_prove', data: '2' }) } />
                    <div>無</div>
                  </div>
                </EAA_ItemContainer>
                {errorAry[5] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
              </EAA_Item>
            </EAA_Row>
          )}
          {data.partner === '國內合資公司' && data.have_prove === '1' && <Sub6 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} checkSubChange={checkSubChange} />}
          {data.partner === '國內合資公司' && data.have_prove === '2' && <Sub7 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} checkSubChange={checkSubChange} />}

        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} forceOpen={returnForceOpen({ least: 6, most: 11 })}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='選擇提供佐證' subtitle='資料種類' subtitleColor='black' haveChange={checkChange('select_data_type')} />
                <EAA_Select displayBorder disabled={disabled} list={IAMTEvidenceTypeList} value={returnInputValue(data.select_data_type)} onChange={data => this.changeData({ label: 'select_data_type', data })} />
              </EAA_ItemContainer>
              {errorAry[6] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
            </EAA_Item>
            <EAA_Item />
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='提供正式商業' subtitle='合約日期' subtitleColor='black' bol={data.select_data_type !== '有條件協議'} haveChange={checkChange('contract_date_type') || checkChange('contract_month') || checkChange('contract_date')} />
                <EAA_Select displayBorder disabled={disabled} marginRight={12} list={IAMTContractDateList} value={returnInputValue(data.contract_date_type)} onChange={data => this.changeData({ label: 'contract_date_type', data })} />
                <EAA_Input displayBorder disabled={disabled} type='number' unit='月' value={returnInputValue(data.contract_month)} onChange={data => this.changeData({ label: 'contract_month', data })} />
              </EAA_ItemContainer>
              {errorAry[7] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇『時間點』' />}
              {errorAry[8] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入『月份』' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} />
                <div style={{ marginRight: 12, flex: 1 }} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.contract_date)} onChange={data => this.changeData({ label: 'contract_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[9] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
          </EAA_Row>

          {data.select_data_type === '替代方案' && (
            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='替代方案' bol haveChange={checkFilesChange('other_plan_upload_files')} />
                  <EAA_Input displayBorder disabled={disabled} hint='方案內容(簡述)' value={returnInputValue(data.other_plan)} onChange={data => this.changeData({ label: 'other_plan', data })} />
                  <EAA_Upload displayBorder disabled={disabled} value={data.other_plan_upload_files || []} onChange={data => this.changeData({ label: 'other_plan_upload_files', data })} />
                </EAA_ItemContainer>
                {errorAry[10] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入『簡述』' />}
                {errorAry[11] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳檔案' />}
              </EAA_Item>
            </EAA_Row>
          )}

          <Sub3 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} checkSubChange={checkSubChange} />

          <Sub4 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} checkSubChange={checkSubChange} />

        </SearchBar>

        {data.select_data_type !== '替代方案' && (
          <SearchBar style={{ marginTop: 8 }} forceOpen={returnForceOpen({ least: 12, most: 15 })}>
            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='合約簽署日期' bol haveChange={checkChange('contract_sign_date')} />
                  <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.contract_sign_date)} onChange={data => this.changeData({ label: 'contract_sign_date', data: getTime.getType3Time(data) })} />
                </EAA_ItemContainer>
                {errorAry[12] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              </EAA_Item>
              <EAA_Item />
            </EAA_Row>

            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='船舶供應時間' bol haveChange={checkChange('provide_start_date') || checkChange('provide_end_date')} />
                  <EAA_Date displayBorder disabled={disabled} hint='開始時間' marginRight={12} value={getTime.returnDate(data.provide_start_date)} onChange={data => this.changeData({ label: 'provide_start_date', data: getTime.getType3Time(data) })} />
                  <EAA_Date displayBorder disabled={disabled} hint='結束時間' value={getTime.returnDate(data.provide_end_date)} onChange={data => this.changeData({ label: 'provide_end_date', data: getTime.getType3Time(data) })} />
                </EAA_ItemContainer>
                {errorAry[13] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇『開始時間』' />}
                {errorAry[14] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇『結束時間』' />}
                {errorAry[15] && <EAA_ErrorText marginLeft={errorLeft} text='『開始時間』不可晚於『結束時間』' />}
              </EAA_Item>
            </EAA_Row>

            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='船舶供應數量' haveChange={checkChange('provide_num')} />
                  <EAA_Input displayBorder disabled={disabled} type='number' unit='艘' value={returnInputValue(data.provide_num)} onChange={data => this.changeData({ label: 'provide_num', data })} />
                </EAA_ItemContainer>
                {/* {errorAry[0] && <ErrorText text='帳號需為 1 ~ 100 英數字。' />} */}
              </EAA_Item>
              <EAA_Item />
            </EAA_Row>

            <Sub5 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} checkSubChange={checkSubChange} />

            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='作業內容' haveChange={checkChange('op_content') || checkChange('op_content_detail')} />
                  <EAA_Select displayBorder disabled={disabled} marginRight={12} list={[{ name: '假內容01', value: '假內容01' }, { name: '假內容02', value: '假內容02' }]} value={returnInputValue(data.op_content)} onChange={data => this.changeData({ label: 'op_content', data })} />
                  <EAA_Input displayBorder disabled={disabled} hint='條件內容(詳答)' value={returnInputValue(data.op_content_detail)} onChange={data => this.changeData({ label: 'op_content_detail', data })} />
                </EAA_ItemContainer>
                {/* {errorAry[0] && <ErrorText text='帳號需為 1 ~ 100 英數字。' />} */}
              </EAA_Item>
            </EAA_Row>

            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='合約價金' haveChange={checkChange('contract_price')} />
                  <EAA_Input displayBorder disabled={disabled} type='number' label='新台幣' hint='價金(金額; 非必填)' unit='元' value={returnInputValue(data.contract_price)} onChange={data => this.changeData({ label: 'contract_price', data })} />
                </EAA_ItemContainer>
                {/* {errorAry[0] && <ErrorText text='帳號需為 1 ~ 100 英數字。' />} */}
              </EAA_Item>
              <EAA_Item />
            </EAA_Row>

            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='條件(但書)' haveChange={checkChange('factor_content')} />
                  <EAA_Memo displayBorder disabled={disabled} hint='條件內容(詳答)' value={returnInputValue(data.factor_content)} onChange={data => this.changeData({ label: 'factor_content', data })} />
                </EAA_ItemContainer>
                {/* {errorAry[0] && <ErrorText text='帳號需為 1 ~ 100 英數字。' />} */}
              </EAA_Item>
            </EAA_Row>
          </SearchBar>
        )}

        <div style={{ height: 16 }} />

        <EAA_Status data={data} />
        <EAA_UpdateTime data={data} />

        <EAA_BottomBtn
          {...{
            data,
            mode,
            isCheck,
            allRight,
            canSend,
            onClose: this._onClose,
            goToCheck: this.goToCheck,
            goToEdit: this.goToEdit,
            add: this.add,
            edit: this.edit,
          }}
        />

        <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewIAOMaritimeData' />
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutIAOMaritimeData' />
      </div>
    );
  }

  render () {
    return (
      <Dialog
        PaperComponent={this.renderDialog}
        open={true}
      />
    );
  }
}

const mapStateToProps = state => ({
  IAOMaritimeIdDetail: state.data.IAOMaritimeIdDetail,

  IAMMItemList: state.data.IAMMItemList,
  IAMTContractDateList: state.data.IAMTContractDateList,
  IAMTPartnerList: state.data.IAMTPartnerList,
  IAMTEvidenceTypeList: state.data.IAMTEvidenceTypeList,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions_Wind.clearKey(dispatch, { key }),
  setPageText: text => Actions.setPageText(dispatch, { text }),
  getBaseData: id => {
    Actions_Wind.getIAMMItemList(dispatch);
    Actions_Wind.getIAMTContractDateList(dispatch);
    Actions_Wind.getIAMTPartnerList(dispatch);
    Actions_Wind.getIAMTEvidenceTypeList(dispatch);
  },
  getIAOMaritimeIdDetail: id => Actions_Wind.getIAOMaritimeIdDetail(dispatch, { id }),
  postAddNewIAOMaritimeData: body => Actions_Wind.postAddNewIAOMaritimeData(dispatch, { body }),
  putIAOMaritimeData: (id, body) => Actions_Wind.putIAOMaritimeData(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
